import { TermsRowActions } from 'modules/cms/terms/components/TermsRowActions';
import { EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { ITerms } from 'modules/cms/terms/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { TERMS_PERMISSIONS } from 'modules/cms/terms/constants/terms.permissions';

export const termsNameColumn: HeadCell<ITerms> = {
  field: 'name',
  headerName: 'terms:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: ITerms) => (<EditLink entityId={data?._id as string}>{name}</EditLink>),
};

export const termsDescriptionColumn: HeadCell<ITerms> = {
  field: 'description',
  headerName: 'terms:fields.description',
};

export const termsActionsColumn: HeadCell<ITerms> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: TERMS_PERMISSIONS.TERMS_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: TermsRowActions,
};

export const termsColumns: Array<HeadCell<any>> = [
  termsNameColumn,
  termsDescriptionColumn,
  createdATColumn,
  termsActionsColumn
];
